"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGlInstancedBinder = void 0;
const a_gl_binder_1 = require("./a-gl-binder");
/**
 * @public
 * Instanced data binder for webgl graphics components.
 */
class AGlInstancedBinder extends a_gl_binder_1.AGlBinder {
    updateInstanced(connector, componentRenderer, divisor, usage) {
        this.updateData(connector);
        this.updatePointers(connector);
        this.bindUniforms(componentRenderer);
        this.bindInstanced(componentRenderer, divisor, usage);
    }
}
exports.AGlInstancedBinder = AGlInstancedBinder;
//# sourceMappingURL=a-gl-instanced-binder.js.map